import { z } from "@/zod";
import { BANK_ACCOUNT_NUMBER_REGEX } from "@/constants";
import { t } from "i18next";
import { isValidNRB } from "./bankAccountNumberValidation";

export const bankAccountNumber = z
  .string()
  .min(26, t("validation.bank_account_number.too_short"))
  .max(26, t("validation.bank_account_number.too_long"))
  .regex(
    BANK_ACCOUNT_NUMBER_REGEX,
    t("validation.bank_account_number.only_digits"),
  )
  .refine((val) => isValidNRB(val), {
    message: t("validation.bank_account_number.checksum_failed"),
  });
